/* eslint-disable no-undef */

window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  // define calm start buttons
  const startDailySessionButton = document.querySelector('[data-name="start_daily_session"]');
  const startAcuteSessionButton = document.querySelector('[data-name="start_acute_session"]');
  const study = await Wized.requests.waitFor('get_study');
  console.log('study', study);
  const user = await Wized.requests.waitFor('get_user');
  console.log('user', user);

  startDailySessionButton.addEventListener('click', async (event) => {
    event.preventDefault();
    var default_text = event.target.textContent;
    var redirect_url = study.data.study.session_page;
    Wized.data.v.session_metadata = { sessionType: 'Daily Practice' };
    try {
      const session = await Wized.requests.execute('create_session');
      startDailySessionButton.textContent = 'Loading Session';
      startDailySessionButton.style.pointerEvents = 'none';
      window.location.href = `${redirect_url}?session_id=${session.data.id}`;
    } catch (error) {
      console.error('Error:', error);
      startDailySessionButton.textContent = default_text;
      startDailySessionButton.style.pointerEvents = 'auto';
    }
  });

  startAcuteSessionButton.addEventListener('click', async (event) => {
    event.preventDefault();
    var default_text = event.target.textContent;
    var redirect_url = '/calm/sessions/002';
    Wized.data.v.session_metadata = { sessionType: 'Acute Episode' };
    try {
      const session = await Wized.requests.execute('create_session');
      startAcuteSessionButton.textContent = 'Loading Session';
      startAcuteSessionButton.style.pointerEvents = 'none';
      window.location.href = `${redirect_url}?session_id=${session.data.id}`;
    } catch (error) {
      console.error('Error:', error);
      startAcuteSessionButton.textContent = default_text;
      startAcuteSessionButton.style.pointerEvents = 'auto';
    }
  });
});
